import { render, staticRenderFns } from "./DashboardAdminDefault.vue?vue&type=template&id=75a21d86&lang=pug"
import script from "./DashboardAdminDefault.vue?vue&type=script&lang=js"
export * from "./DashboardAdminDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports